export const ENTERPRISES_INDEX__SET_ALL = 'ENTERPRISES_INDEX__SET_ALL';
export const ENTERPRISES_INDEX__ADD_RESOURCE = 'ENTERPRISES_INDEX__ADD_RESOURCE';
export const ENTERPRISES_INDEX__UPDATE_RESOURCE = 'ENTERPRISES_INDEX__UPDATE_RESOURCE';
export const ENTERPRISES_INDEX__REMOVE_RESOURCE = 'ENTERPRISES_INDEX__REMOVE_RESOURCE';
export const ENTERPRISES_INDEX__CLEAR_ALL = 'ENTERPRISES_INDEX__CLEAR_ALL';
